var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.115,
    height: 15.728,
    viewBox: "0 0 13.115 15.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2f3061;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.23 -370.606)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-226.23 370.606)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-220.989,378.421q0-2.791,0-5.582a9.715,9.715,0,0,1,.046-1.139,1.268,1.268,0,0,1,1.271-1.094,1.28,1.28,0,0,1,1.27,1.1,4.047,4.047,0,0,1,.031.569q0,2.855,0,5.709v.551c.565-.534,1.034-1.018,1.549-1.446a2.041,2.041,0,0,1,.883-.442,1.281,1.281,0,0,1,1.365.746,1.323,1.323,0,0,1-.3,1.567q-2.154,2.143-4.319,4.273c-.135.133-.287.247-.431.371l.044.119h.368q2.324,0,4.649,0a1.318,1.318,0,0,1,1.448,1.315,1.333,1.333,0,0,1-1.436,1.294q-5.118.006-10.236,0A1.335,1.335,0,0,1-226.229,385a1.319,1.319,0,0,1,1.443-1.28q2.3,0,4.608,0h.5c-.179-.186-.292-.308-.411-.425-1.459-1.444-2.925-2.881-4.376-4.332a1.337,1.337,0,0,1,.564-2.293,1.308,1.308,0,0,1,1.343.374c.473.483.932.98,1.4,1.47Z",
    transform: "translate(226.23 -370.606)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.dad629fa5a6100afded127209c22fa3e.svg";
export { ForwardRef as ReactComponent };